import HotelGuide from '@components/Hotel/MultiStore/Guide'
import Guide from '@components/LocalMerchant/MultiStore/Guide'
import Upgrade from '@components/LocalMerchant/MultiStore/Upgrade'
import { isHotelProperty } from '@merchant-backend/util'

export default {
  path: 'multiStore',
  indexRoute: {
    component: isHotelProperty() ? HotelGuide : Guide
  },
  childRoutes: [
    {
      path: 'upgrade',
      component: Upgrade
    }
  ]
}
